<template>
  <v-snackbar
    v-model="show"
    :bottom="true"
    :right="true"
    :color="mode"
    :timeout="3500"
  >
    {{ message }}
    <v-btn
      dark
      text
      @click="show = false"
    >
      {{ $vuetify.lang.t('$vuetify.close') }}
    </v-btn>
  </v-snackbar>
</template>

<script>
import objectPath from 'object-path';

export default {
  data: () => {
    return {
      show: false,
      message: '',
      mode: '',
    };
  },
  computed: {
    snackbar() {
      return this.$store.state.snackbar;
    },
  },
  watch: {
    snackbar: {
      handler() {
        if (Object.keys(this.$store.state.snackbar).length > 0) {
          if (objectPath.get(this.$store.state, 'snackbar.text', '') !== '') {
            this.show = true;
            this.message = this.$store.state.snackbar.text;
            this.mode = objectPath.get(this.$store.state, 'snackbar.mode', 'info');
            this.$store.dispatch('setSnackbar', {});
          }
        }
      },
      immediate: true,
    },
  },
};
</script>
